// extracted by mini-css-extract-plugin
export default {"aboutUs":"AboutUs_aboutUs__1hcCn","text_item":"AboutUs_text_item__rlgBh","aboutUs_image":"AboutUs_aboutUs_image__ESXY8"};